export * from './aside';
export * from './nav-dropdown';
export * from './replace';
export * from './sidebar';
export * from './teamid2teamname';
export * from './roleid2rolename';
export * from './displayid';
export * from './pm-statusnum2statusname';
export * from './customer-status2statusname';
export * from './ecall-statusnum2statusname';
export * from './no-dbl-click';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/index.ts